import React, { useEffect, useState } from 'react'
import { LinkDataType } from './AddLink'
import Select from 'react-select';
import { isValidURL } from '../../utils/helpers';
import LinkPreview from './LinkPreview';
import { Post } from '../../types/influencer/influencerTypes';
import TriggersSelection from '../inputs/TriggersSelection';
import { useSelector } from 'react-redux';
import { RootState } from '../../redux-stores/store';
import { SocialPost } from '../../types/collaborations/CollaborationTypes';

interface LinkPostFieldsProps {
    link: LinkDataType,
    setLink: React.Dispatch<React.SetStateAction<LinkDataType>>,
    editMode?: boolean
    onSubmit: () => void,
    onCancel: () => void,
    disableSubmission: boolean,
    viewOnly?: boolean,
    formErrors?: any,
    post: SocialPost
}

const LinkPostFields: React.FC<LinkPostFieldsProps> = ({ link, setLink, editMode = false, onSubmit, onCancel, disableSubmission = false, viewOnly = false, formErrors={}, post }) => {

    const [errors, setErrors] = useState<any>({})

    const selectedSocialAccount = useSelector((state: RootState) => state.dmAutomationsList.selectedSocialAccount);

    const buttonTextOptions = useSelector((state: RootState) => state.dmAutomationsList.automations[selectedSocialAccount?.social_account?.uuid!].button_text_list);

    useEffect(() => {
        setErrors(formErrors);
    }, [formErrors])

    const validate = () => {
        let validation_errors: any = {};
        if (!link.triggers || !Array.isArray(link.triggers) || link.triggers.length < 1) {
            validation_errors["triggers"] = "Add atleast one trigger";
        }

        if (!link.url || !isValidURL(link.url)) {
            validation_errors['url'] = "Please enter a valid URL";
        }

        if (!link.button_text) {
            validation_errors['button_text'] = "Button text is required"
        }

        setErrors(validation_errors);

        return Object.keys(validation_errors).length < 1;

    }

    const submit = async () => {
        const isValid = validate();
        if (!isValid) return;
        onSubmit();
    }

    return (
        <div className='bg-theme mx-n2 p-3 pt-0 rounded-sm'>
            <div className="mb-2">
                <React.Fragment>
                    <label className="font-12 d-block">
                        Triggers (Max 3) <span className="text-danger">*</span>
                    </label>
                    <TriggersSelection 
                        triggers={link.triggers}
                        onChange={(triggers) => setLink({...link, triggers})}
                        isDisabled={viewOnly}
                    />
                </React.Fragment>
                {errors.triggers && (
                    <small className="text-danger mt-n4" >
                        <i className="fa fa-times color-red-dark"></i> {errors.triggers}
                    </small>
                )}
            </div>
            <div className="mb-2">
                <React.Fragment>
                    <label className="font-12 d-block">
                        Target URL <span className="text-danger">*</span>
                    </label>
                    <div className={`input-style has-borders validate-field mb-0 ${errors.url ? "invalid" : ""}`} style={{ marginBottom: '0px !important' }}>
                        <input
                            type="text"
                            disabled={editMode || viewOnly}
                            className="form-control form-control-sm"
                            id="btn-url"
                            name="url"
                            placeholder="Enter Link"
                            style={{ height: '38px', borderRadius: '5px', borderColor: '#cccccc' }}
                            value={link.url}
                            onChange={e => setLink({ ...link, url: e.target.value })}
                        />
                    </div>
                    {errors.url && (
                        <small className="text-danger mt-n4" >
                            <i className="fa fa-times color-red-dark"></i> {errors.url}
                        </small>
                    )}
                </React.Fragment>
            </div>
            <div className="mb-2">
                <React.Fragment>
                    <label className="font-12 d-block">
                        Button Text <span className="text-danger">*</span>
                    </label>
                    <Select  
                        value={link.button_text ? { label: link.button_text, value: link.button_text } : null}
                        options={buttonTextOptions.map((text) => ({ label: text, value: text }))}
                        onChange={(selectedOption) => setLink({ ...link, button_text: selectedOption?.value ?? "" })}
                        placeholder="Select Button Text"
                        isDisabled={viewOnly}
                    />
                </React.Fragment>
                {errors.button_text && (
                    <small className="text-danger mt-n4" >
                        <i className="fa fa-times color-red-dark"></i> {errors.button_text}
                    </small>
                )}
            </div>
            <div className="mb-2 mt-3">
                <LinkPreview link={link} post={post} />
            </div>
            <div className="divider my-3"></div>
            {
                !viewOnly &&
                <div className="d-flex justify-content-between align-items-center mt-3 gap-2">
                    <button onClick={onCancel} className='btn btn-outline-primary btn-sm w-100 rounded-sm'>Cancel</button>
                    <button disabled={disableSubmission} onClick={submit} className='btn btn-primary btn-sm w-100 rounded-sm'>Done</button>
                </div>
            }
        </div>
    )
}

export default LinkPostFields